
import utilsModel from "../../../../../engines/libs/utilsModel";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { MansionKind } from "../../../../define/MansionKind";
import ChildData from "./ChildData";

export default class ChildDataManage {

    childData = new ChildData();
 
    loadLocationData() {
        this.childData.loadLocalData();
    }

    saveAllLocationData() {
        this.childData.saveLocalData();
    }

    /**
     * 每天数据处理
     */
    dayDataDispose() {

        let subIntimate = Number(MansionKind.GeneralValue.CHILD_SUB_INTIMATE);
        let bChange = false;
        this.childData.lists.forEach((v)=> {
            if (v.intimacy <= 0) {
                return;
            }
            bChange = true;
            let intimacy = v.intimacy - subIntimate;
            v.intimacy = Math.max(0, intimacy);
        });
        
        if (bChange) {
            this.childData.saveLocalData();
        }
    }

    /**
     * 子女数量
     * @returns 
     */
    ownChildCount(bOnlyMansion: boolean = false) {
        let count = 0;
        this.childData.lists.forEach((v)=> {
            if (bOnlyMansion) {
                if (v.bEnterMansion) {
                    count++;
                }
            } else {
                count++;
            }
        });
        return count;
    }

    /**
     * 获得亲密度信息
     * @param intimate 
     * @returns 
     */
    getIntimateInfo(intimate: number) {
        let csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.CHILD_INTIMACY);
        if (!csvInfos) {
            console.error('未找到CHILD_INTIMACY表格数据');
            return null;
        }
        let title = csvInfos.title;
        for (let i in csvInfos) {
            if (i == 'title' || i == '' || i.trim() == '') {
                continue;
            }
            let info = csvInfos[i];
            let iMin = info[title.good_min];
            let iMax = info[title.good_max];
            if (intimate < Number(iMin)) {
                continue;
            }

            if (utilsModel.isValidNumberValue(iMax)) {
                if (intimate > Number(iMax)) {
                    continue;
                }
            }
            return CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.CHILD_INTIMACY, i);
        }
        return null;
    }
}
